import styled from 'styled-components';
import { IStyledCheckbox } from 'src/components/Input/CheckboxInput/CheckboxInput.i';

export const CheckboxContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
  margin-right: 8px;
  padding-top: 7px;
`;
export const Checkmark = styled.svg`
  fill: none;
  stroke: ${(props) => props.theme.black[70]};
  stroke-width: 4px;
  display: block;
`;
export const HiddenInput = styled.input`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: fixed;
  white-space: nowrap;
  width: 1px;
`;

export const StyledCheckbox = styled.div<IStyledCheckbox>`
  display: inline-block;
  width: 16px;
  height: 16px;
  background: ${(props) => (props.checked ? props.theme.gold[50] : '')};
  border-radius: 3px;
  border: 1px solid #444f5b;
  transition: all 150ms;
  vertical-align: text-top;
  ${HiddenInput}:focus + & {
    ${(props) => props.theme.focusBoxShadow};
  }
  ${Checkmark} {
    visibility: ${(props) => (props.checked ? 'visible' : 'hidden')};
  }
`;
